import { Form, Input } from 'antd'
import React from 'react'

const EVerifyHealthForm = () => {
    return (
        <div className="row">
            <div className="col-sm-6 labelSSS">
                <Form.Item
                    name='Policy'
                    label="Policy #"
                    rules={[
                        {
                            required: true,
                            message: "Please Enter Policy Number!"
                        }
                    ]}
                >
                    <Input placeholder='Policy #' />
                </Form.Item>

            </div>
            <div className="col-sm-6 labelSSS">
                <Form.Item
                    name='Health'
                    label="Health ID"
                    rules={[
                        {
                            required: true,
                            message: "Please Enter Health ID!"
                        }
                    ]}
                >
                    <Input placeholder='Health ID' />
                </Form.Item>
            </div>

        </div>
    )
}

export default EVerifyHealthForm